/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Router } from "@angular/router";

import { AuthenticationService } from './authentication.service';
import { BaseService } from "./base-service";
import { HealthData } from "../models/healthData";
import { RestService } from './rest-service';

@Injectable()
export class HealthMonitorService extends BaseService {
  private url = 'http://192.168.4.140:8080/healthMonitor%2D1/uptime';

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private restService: RestService
  ) { super(router, authenticationService); }

  getUrl(): string {
    return this.url;
  }

  getUptimeDataForServer(id: string): Promise<HealthData> {
    const callUrl = this.getUrl() + "?server=" + id;
    return this.restService.get<HealthData>(callUrl);
  }

}
